<template>
    <div id="app">
        <router-view ref="childs"/>
    </div>
</template>

<script>
    export default {
        name: 'App',
        data(){
            return {

            }
        },
		
        mounted() {
                this.init();
                console.log(this.$api.apiUrl)
		},
        methods:{
			init(){
                var that = this
                var apiUrl = this.$api.apiUrl
                var obj = window.location.href
                if(obj.split("?")&&obj.split("?")[1]=='hide'){
                    // 如果过来的参数是隐藏hide的 只能浏览网站不能更改网站
                    localStorage.clear()
                    localStorage.setItem('states1',3)
                }else if(obj.split("?")&&obj.split("?")[1]=='clearToken'){
                    localStorage.clear()
                }else{
                    localStorage.removeItem('states1')
                }
                var objt = obj.substring(0,20)//正式环境
                var pushName = obj.substr(obj.lastIndexOf('?')+1,obj.length).split('=')[0]
                var name = obj.substr(obj.lastIndexOf('?')+1,obj.length).split('=')[1]
                if(pushName=='pushName'){
                    var name = obj.substr(obj.lastIndexOf('?')+1,obj.length).split('=')[1]
                    if(name=='Qyindex'){
                        that.$router.push({name:name})
                    }else{
                        that.$router.replace({name:name})
                    }
                }else if(apiUrl != objt){
					var objs = obj.split("?");
					if(objs[1]){
						console.log(objs[1])
					}else{
						if(localStorage.getItem('navname') == 'Talentcommunity' || localStorage.getItem('navname') == 'Socialrecruitment' || localStorage.getItem('navname') == 'Companyshow' || localStorage.getItem('navname') == 'Campusshow' || localStorage.getItem('navname') == 'Webpagepz'){
							that.$router.push({name:localStorage.getItem('navname')})
						}else {
								// that.$router.push({name:'Qyindex'})
							}
					}
                }else if(apiUrl == objt){
                        localStorage.removeItem('states1')
                }else{

                }
			},
			
			
        },
            // 数据变化监控
	watch: {
		$route(to, from){
			// 判断导航登录状态显示与否
			if(localStorage.getItem('states1')){
                setTimeout(()=>{
                    if(this.$refs.childs){
                        this.$refs.childs.tabbar();
                        console.log('走了这里tabbar'+'tabbar')
                    }
                },0)
                console.log('没有走这里tabbar'+'tabbar')
			}
		}
	},
    }
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        width: 100%;
        height: 100%;
        margin: 0px;
        padding: 0px;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue